import { AnyGame } from '@/types';

// Cache global de jogos: garante que a tela de detalhe sempre mostra
// o jogo correto independente da fonte (ESPN vs api-sports.io)
const _cache = new Map<string, AnyGame>();

export const gameCache = {
  set(game: AnyGame) {
    _cache.set(`${game.sport}:${game.id}`, game);
  },

  setForKey(sport: string, id: string, game: AnyGame) {
    _cache.set(`${sport}:${id}`, game);
  },

  setMany(games: AnyGame[]) {
    games.forEach((g) => _cache.set(`${g.sport}:${g.id}`, g));
  },

  get(sport: string, id: string): AnyGame | undefined {
    return _cache.get(`${sport}:${id}`);
  },

  has(sport: string, id: string): boolean {
    return _cache.has(`${sport}:${id}`);
  },
};
